export const env = {
  // NODE_ENV: "dev",
  // NODE_ENV: "homolog",
  NODE_ENV: "prod",

  API_DEV: "https://developer.teamsoft.com.br",
  ORIGIN_DEV: "https://developer.teamsoft.com.br",

  API_HOMOLOG: "https://api.homolog.teamsoft.com.br",
  ORIGIN_HOMOLOG: "https://dominos.teamsoft.com.br",

  API_PROD: "https://api.domlivery.dominos.com.br",
  ORIGIN_PROD: "",
};
